const SUBMITTED_REVIEW_REDIRECT_KEY = 'submittedReviewRedirectBuildingSlugs';

function readSubmittedReviewRedirects() {
  if (typeof window === 'undefined') return new Set<string>();

  const raw = window.sessionStorage.getItem(SUBMITTED_REVIEW_REDIRECT_KEY);
  if (!raw) return new Set<string>();

  try {
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return new Set<string>();
    return new Set(
      parsed.filter((slug): slug is string => typeof slug === 'string' && slug.length > 0),
    );
  } catch {
    return new Set<string>();
  }
}

function writeSubmittedReviewRedirects(slugs: Set<string>) {
  if (typeof window === 'undefined') return;
  window.sessionStorage.setItem(SUBMITTED_REVIEW_REDIRECT_KEY, JSON.stringify([...slugs]));
}

export function markSubmittedReviewForRedirect(buildingSlug: string) {
  if (!buildingSlug) return;
  const slugs = readSubmittedReviewRedirects();
  slugs.add(buildingSlug);
  writeSubmittedReviewRedirects(slugs);
}

export function hasSubmittedReviewRedirect(buildingSlug: string) {
  if (!buildingSlug) return false;
  return readSubmittedReviewRedirects().has(buildingSlug);
}

export function clearSubmittedReviewRedirect(buildingSlug: string) {
  if (!buildingSlug) return;
  const slugs = readSubmittedReviewRedirects();
  slugs.delete(buildingSlug);
  writeSubmittedReviewRedirects(slugs);
}
